/**
 * @module app.shared
 */

import { convertToString } from "app/shared/lib/utilities";

export class JoinValueConverter {

    public toView(value: unknown, separator: unknown = ', '): any {
        // no value, return value
        if(value === null || value === undefined) {
            return value;
        }

        let separatorString: string = convertToString(separator);

        if(Array.isArray(value)) {
            return value.join(separatorString);
        }
        return value;
    }
}
